import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["name", "id", "disabled", "required"]
const _hoisted_3 = {
  key: 0,
  value: "",
  hidden: "",
  disabled: "",
  selected: ""
}
const _hoisted_4 = ["label"]
const _hoisted_5 = ["value", "selected"]
const _hoisted_6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "svg-inline": '',
  class: /*@__PURE__*/_normalizeClass('icon'),
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_7 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "input" }, _ctx.$attrs), [
    _createElementVNode("div", {
      class: _normalizeClass(["field", [
        {
          isLabelAtop: _ctx.isLabelAtop,
          hasLabel: _ctx.label,
          isRequired: _ctx.required,
          isDisabled: _ctx.disabled,
        },
      ]])
    }, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _ctx.inputId
          }, _toDisplayString(_ctx.label), 9, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("select", {
        ref: "selectElement",
        name: _ctx.inputName,
        id: _ctx.inputId,
        class: _normalizeClass(["select", { isEmpty: !_ctx.modelValue }]),
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args))),
        disabled: _ctx.disabled,
        required: _ctx.required
      }, [
        (!_ctx.prefill && !_ctx.placeholder)
          ? (_openBlock(), _createElementBlock("option", _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.placeholder)
          ? (_openBlock(), _createElementBlock("option", {
              key: 1,
              value: "",
              label: _ctx.placeholder,
              hidden: "",
              disabled: "",
              selected: ""
            }, _toDisplayString(_ctx.placeholder), 9, _hoisted_4))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.id,
            key: option.id,
            selected: _ctx.modelValue === option.id
          }, _toDisplayString(option.title), 9, _hoisted_5))
        }), 128))
      ], 42, _hoisted_2),
      (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("path", { d: "M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42z" }, null, -1)
      ]))]))
    ], 2),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ], 16))
}